<h2 class="text-2xl font-semibold text-gray-800 my-4">{{ "changeOwner.title" | translate }}</h2>
<form [formGroup]="rootFormGroup" (ngSubmit)="onSubmit()">
    <app-chip-search
        class="hidden"
        [formGroup]="getChipForm()"
        [isRegistration]="false"
        (isChipReadyForRegistration)="updateChipModificationStatus($event)" />

    <div class="rounded-2xl border border-gray-200 bg-white mb-4">
        <div class="px-6 py-5 flex flex-row items-center justify-between">
            <h3 class="text-base font-medium text-gray-800">
                {{ "chipRegistration.microchip.sectionTitle" | translate }}
                @if (chipDetails) {
                    #{{ chipDetails.codeInfo.code }}
                }
            </h3>
        </div>
        <div class="border-t border-gray-200 p-4">
            <app-chip-info-form [formGroup]="getChipInfoForm()" [isRegistration]="false" [vets]="veterinariansList" />
        </div>
    </div>

    <div class="rounded-2xl border border-gray-200 bg-white mb-4">
        <div class="px-6 py-5">
            <h3 class="text-base font-medium text-gray-800">
                {{ "chipRegistration.owner.sectionTitle" | translate }}
            </h3>
        </div>
        <div class="border-t border-gray-200 p-4">
            <app-owner-form [formGroup]="getOwnerForm()" />
        </div>
    </div>

    <div class="rounded-2xl border border-gray-200 bg-white mb-4">
        <div class="px-6 py-5">
            <h3 class="text-base font-medium text-gray-800">
                {{ "chipRegistration.animal.sectionTitle" | translate }}
            </h3>
        </div>
        <div class="border-t border-gray-200 p-4">
            <app-animal-form [formGroup]="getAnimalForm()" [isAddressControlVisible]="false" />
        </div>
    </div>

    <div class="rounded-2xl border border-gray-200 bg-white mb-4">
        <div class="px-6 py-5">
            <h3 class="text-base font-medium text-gray-800">
                {{ "chipRegistration.animalAddress.sectionTitle" | translate }}
            </h3>
        </div>
        <div class="border-t border-gray-200 p-4">
            <app-animal-address-form [formGroup]="getAnimalAddressForm()" [isAddressSameAsOwner]="animalAddressSameAsOwner" />
        </div>
    </div>

    <p-button severity="primary" size="large" type="submit" [disabled]="!rootFormGroup.valid" [label]="'common.submit' | translate" />
</form>
